import {appendPaginationQueryParamsToUrl, get} from '../utils'

const url = (host, type, tags, countryId, search, options) =>
  appendPaginationQueryParamsToUrl(`${host}/contentCreators?type_name=${type}&tags_ids=${tags.join(',')}${addFilters(countryId, search)}&active=1&type=talent&include=tags;image;type;favorite`, {...options, alreadyHasQueryParams: true});


const addFilters = (countryId, search) => {
  let filters = '';

  if (countryId) {
    filters += `&country[id]=${countryId}`
  }

  if (search) {
    filters += `&q=${search}`
  }
  return filters
}

export default host => (type, tags, countryId, search, options) =>
  get(url(host, type, tags,  countryId, search, options))
    .then(response => response.json())
    .then(json => json.meta ? json : json.data)